export function sortedCollectionUrl(currentUrl, sortBy) {
  const url = new URL(currentUrl);
  url.searchParams.set('sort_by', sortBy);
  url.searchParams.delete('page');
  url.searchParams.delete('section_id');
  return url;
}

export function categoryCollectionUrl(destination, currentUrl) {
  const current = new URL(currentUrl);
  const url = new URL(destination, current);
  for (const name of ['sort_by', 'preview_theme_id']) {
    const value = current.searchParams.get(name);
    if (value) url.searchParams.set(name, value);
  }
  return url;
}

export function sortPreviewProducts(products, sortBy) {
  return [...products].sort((a, b) => {
    let difference = 0;
    if (sortBy === 'price-ascending') difference = Number(a.price) - Number(b.price);
    if (sortBy === 'price-descending') difference = Number(b.price) - Number(a.price);
    if (sortBy === 'title-ascending') difference = a.title.localeCompare(b.title, 'en');
    if (sortBy === 'title-descending') difference = b.title.localeCompare(a.title, 'en');
    if (sortBy === 'created-ascending') difference = Date.parse(a.createdAt) - Date.parse(b.createdAt);
    if (sortBy === 'created-descending') difference = Date.parse(b.createdAt) - Date.parse(a.createdAt);
    return difference || Number(a.position) - Number(b.position);
  });
}

export function filterPreviewProducts(products, params) {
  const sizes = params.getAll('preview_size');
  const finishes = params.getAll('preview_finish');
  const cap = params.get('preview_price_max');
  const maxPrice = cap !== null && cap !== '' ? Number(cap) * 100 : Infinity;
  const sizeValues = ['60x60 Inch (4 Seater)', '60x90 Inch (6 Seater)'];
  return products.flatMap(product => {
    if (finishes.length && !finishes.includes(product.finish)) return [];
    const prices = [Number(product.price), Number(product.largePrice)];
    const matchingPrices = prices.filter((price, index) => (!sizes.length || sizes.includes(sizeValues[index])) && Number.isFinite(price) && price <= maxPrice);
    return matchingPrices.length ? [{ ...product, price: Math.min(...matchingPrices) }] : [];
  });
}

function initializeDraftFilters() {
  const params = new URLSearchParams(location.search);
  const bestsellerTemplate = document.querySelector('[data-bestseller-draft-template]');
  if (bestsellerTemplate && params.get('preview_category') === 'tablecloths') {
    document.getElementById('CollectionProductContainer').replaceChildren(bestsellerTemplate.content.cloneNode(true));
  }
  const grid = document.querySelector('[data-draft-tablecloth-grid]');
  if (!grid) return;
  const cards = [...grid.children].map(element => ({ ...element.dataset, element }));
  const matching = filterPreviewProducts(cards, params);
  const visibleCards = new Map(matching.map(card => [card.element, card]));
  cards.forEach(card => {
    const matchingCard = visibleCards.get(card.element);
    card.element.hidden = !matchingCard;
    if (!matchingCard) return;
    const price = card.element.querySelector('[data-preview-card-price]');
    if (price) price.innerHTML = Number(matchingCard.price) === Number(card.largePrice) ? card.largeMoney : card.smallMoney;
  });
  sortPreviewProducts(matching, params.get('sort_by')).forEach(card => grid.append(card.element));
  document.querySelectorAll('[data-filter-product-count]').forEach(node => {
    node.textContent = `${matching.length} ${matching.length === 1 ? node.dataset.productSingular : node.dataset.productPlural}`;
  });
  const empty = document.querySelector('[data-draft-preview-empty]');
  if (empty) empty.hidden = matching.length > 0;
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeDraftFilters, { once: true });
  else initializeDraftFilters();
}
